import { Component, OnInit, ViewContainerRef, ViewChild } from "@angular/core";
import { IFilterAngularComp } from "ag-grid-angular";
import {
  IFilterParams,
  RowNode,
  IDoesFilterPassParams,
} from "ag-grid-community";
import { TextFloatingFilterComp } from "ag-grid-community/dist/lib/filter/floatingFilter";
import { TextFloatingFilterComponent } from "../text-floating-filter/text-floating-filter.component";

@Component({
  selector: "app-text-filter",
  templateUrl: "./text-filter.component.html",
  styleUrls: ["./text-filter.component.css"],
})
export class TextFilterComponent implements IFilterAngularComp {
  private params: IFilterParams;
  private valueGetter: (rowNode: RowNode) => any;
  public text: any = ""; // need to be public for --prod compile

  @ViewChild("input", { read: ViewContainerRef }) public input;

  isFilterActive(): boolean {
    return true;
  }

  getParent(node) {
    let parent = node;
    if (node.parent.data !== undefined) {
      parent = this.getParent(node.parent);
    }

    return parent;
  }

  getFilterType(filterText: string) {
    if (filterText !== "") {
      if (filterText.startsWith("%") && filterText.endsWith("%")) {
        return "contains";
      } else if (filterText.startsWith("%")) {
        return "endsWith";
      } else if (filterText.endsWith("%")) {
        return "startsWith";
      } else {
        return "startsWith";
      }
    } else {
      return "startsWith";
    }
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    let newFilterText = String(this.text).replace("%", "").toLowerCase();
    newFilterText = String(newFilterText).replace("%", "").toLowerCase();
    if (params.node.parent.data !== undefined) {
      // get top level parent however many levels up
      const parent = this.getParent(params.node.parent);

      const filterType = this.getFilterType(this.text);
      const parentData =
        this.valueGetter(parent) === undefined ||
        this.valueGetter(parent) === null
          ? ""
          : this.valueGetter(parent);
      switch (filterType) {
        case "startsWith":
          // return this.valueGetter(parent).toString().toLowerCase().indexOf(newFilterText) === 0;
          return (
            parentData.toString().toLowerCase().indexOf(newFilterText) === 0
          );
          break;
        case "endsWith":
          // return this.valueGetter(parent).toString().toLowerCase().endsWith(newFilterText);
          return parentData.toString().toLowerCase().endsWith(newFilterText);
          break;
        case "contains":
          // return this.valueGetter(parent).toString().toLowerCase().indexOf(newFilterText) > -1;
          return (
            parentData.toString().toLowerCase().indexOf(newFilterText) > -1
          );
          break;
      }
    } else {
      const filterType = this.getFilterType(this.text);
      const nodeData =
        this.valueGetter(params.node) === undefined ||
        this.valueGetter(params.node) === null
          ? ""
          : this.valueGetter(params.node);
      switch (filterType) {
        case "startsWith":
          // return this.valueGetter(params.node).toString().toLowerCase().indexOf(newFilterText) === 0;
          return nodeData.toString().toLowerCase().indexOf(newFilterText) === 0;
          break;
        case "endsWith":
          return nodeData.toString().toLowerCase().endsWith(newFilterText);
          break;
        case "contains":
          return nodeData.toString().toLowerCase().indexOf(newFilterText) > -1;
          break;
      }
    }
    //   console.log(this.valueGetter(params.node).toLowerCase() + 'parent ' + params.node.parent.data);
    //    console.log('doesFilterPass ' + JSON.stringify(params.node.data));
    //    console.log('doesFilterPass ' + this.valueGetter(params.node).toLowerCase() + ' ' + params.node.parent);
    //    console.log(JSON.stringify(this.valueGetter(params.node)));
    /*
    return this.text.toLowerCase()
      .split(" ")
      .every((filterWord) => {
        return this.valueGetter(params.node).toString().toLowerCase().indexOf(filterWord) == 0;
      });
  */
  }
  getModel() {
    return { value: this.text };
  }
  setModel(model: any): void {
    this.text = model ? model.value : "";
  }

  getModelAsString(model: any): string {
    return model ? model.value : "";
  }

  agInit(params: IFilterParams): void {
    this.params = params;
    this.valueGetter = params.valueGetter;
    this.params.colDef.floatingFilterComponent = TextFloatingFilterComponent;
    // this.params.colDef.floatingFilterComponent = BooleanDropdownFloatingFilter;
  }

  onChange(newValue): void {
    if (this.text !== newValue) {
      this.text = newValue;
      this.params.filterChangedCallback();
    }
  }

  onFloatingFilterChanged(newValue): void {
    this.onChange(newValue);
  }
}
